import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { PiSituationProfessionnelle } from '../models/options/piSituationsProfessionnelles/piSituationProfessionnelle';

const resource = 'PISituationsProfessionnelles'

export default class PISituationProfessionnellesRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<PiSituationProfessionnelle>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
